import { resolve } from 'styled-jsx/css';
import { fontFamilies } from '../UI/Font';

export const getBoxStyle = (squareBorder?: boolean, padding?: string): { className: string; styles: string } =>
  resolve`
  .extended-footer-box {
    flex: 1;
    flex-direction: column;
    align-items: center;
    min-height: 258px;
    display: flex;
  }

  @media (max-width: 1023px) {
    .extended-footer-box {
      justify-content: center;
      border-top: 2px solid #eeeef0;
      padding: ${padding || '0 66px 0'};
    }

    .extended-footer-box:last-of-type { 
      padding: ${padding || '55px 66px 35px'};
    }
  }

  @media (min-width: 1024px) {
    .extended-footer-box {
      padding: 0 26px;
      ${squareBorder ? 'border: 4px solid #eeeef0;' : ''}
    }
    .extended-footer-box:not(:last-of-type) {
      ${squareBorder ? 'border-right: 0;' : ''}
      ${!squareBorder ? 'border-right: 4px solid #eeeef0;' : ''}
    }
  }
`;

export const getTextStyle = (): { className: string; styles: string } => resolve`
  .extended-footer-text, .extended-footer-text :global(*) {
    color: #000000;
    font-family: ${fontFamilies.light};
    font-size: 15px;
    font-weight: 300;
    line-height: 20px;
    text-align: center;
  }

  .bottom {
    margin-bottom: 33px;
    margin-top: 20px;
  }
`;

export const getTitleStyle = (color?: string): { className: string; styles: string } => resolve`
  .extended-footer-title {
    text-align: center;
    font-family: ${fontFamilies.regular};
    font-size: 15px;
    font-weight: 900;
    line-height: 20px;
    margin-top: 34px;
    margin-bottom: 20px;
  }

  .extended-footer-title {
    color: ${color || '#000000'};
  }

  @media (max-width: 1023px) {
    .extended-footer-title {
      margin-top: 0px;
    }
  }
`;
